// extracted by mini-css-extract-plugin
export default {"link":"LinkAuthFlowWebview_link__OTHHn"};